import FieldDefinition from '../../../types/common/FieldDefinition';
import stringHelper from '../../../infrastructure/helpers/common/stringHelper';
import typeHelper from '../../../infrastructure/helpers/common/typeHelper';
import { findDuplicateNamesCaseInsensitive ,findDuplicateNamesCaseSensitive} from './FieldDefinitions.Helpers';

const nameMaxCharCount = 100;
const commentMaxCharCount = 2000;

const validateOne = (definition: FieldDefinition): string | null => {

    if (stringHelper.isEmpty(definition.name)) {
        return 'Field definiton name is required';
    }

    if (definition.name.length > nameMaxCharCount) {
        return `Field definiton name max character count is ${nameMaxCharCount}`;
    }

    if (typeHelper.isString(definition.comment) && definition.comment.length > commentMaxCharCount) {
        return `Field definiton comment max character count is ${commentMaxCharCount}`;
    }

    return null;
};

const validate = (definitions: FieldDefinition[], isTransposed: boolean | null): string | null => {

    if (definitions.length === 0) {
        return 'At least one field is required';
    }

    let errors = definitions.map(validateOne).filter(x => x);
    if (errors.length > 0) {
        return errors[0];
    }

    let definitionsAlternativeNames = definitions.filter(field => field.alternativeNames)
        .map(field => field.alternativeNames);

    let definitionsMainNames = definitions.map(field => field.name);

    let duplicateNames:string[][] = findDuplicateNamesCaseInsensitive(definitionsMainNames)

    duplicateNames.forEach((duplicateNames: string[]) => {
            errors.push(`Duplicate field definition names: ${duplicateNames.join(', ')}`);
    });

    if (errors.length > 0) {
        return errors[0];
    }

    if (definitionsAlternativeNames) { 
        definitionsAlternativeNames.forEach((an) => {
            let duplicateNames: string[] = findDuplicateNamesCaseSensitive(an as string[])

            duplicateNames.forEach((duplicateName: string) => {
                    errors.push(`Duplicate alternative names: ${duplicateName}`);
            });
        });
    } 

    if (errors.length > 0) {
        return errors[0];
    }

    //if (isTransposed) {
    //    if (definitions.length !== 2) {
    //        return 'Exactly two fields are required for transposed configs';
    //    }

    //    if (!definitions[0].name.toLowerCase().endsWith('key')) {
    //        return 'First field must end with `key` for transposed configs';
    //    }

    //    if (definitions[0].type !== dataType.string) {
    //        return 'First field type must be `String` for transposed configs';
    //    }

    //    if (!definitions[1].name.toLowerCase().endsWith('value')) {
    //        return 'Second field must end with `value` for transposed configs';
    //    }
    //}

    return null;
};

export default validate;
